import { getEnv } from './../../modules/utility';
import { CgpApplications, LOCAL_MAP } from './../../config/config.broadcast';

export class CgpApplication {
    applicationId: string;
    env: string;
}

export function getApplication(): CgpApplication | null {
    const env = getEnv() === 'LOCAL' ? LOCAL_MAP : getEnv();

    return env in CgpApplications
        ? {
            applicationId: CgpApplications[env],
            env: env.toLowerCase()
        }
        : null;
}